// LICENSE_CODE ZON
/*jslint browser:true, es6:true, node:true, react:true*/
import {i_user_info} from 'hola_app_context';
import {get} from 'zutil';

export const get_payment_opts = (user: i_user_info, email: string)=>{
    if (!email && user)
        email = get(user, 'emails[0].value');
    let fake_user = null;
    if (!user)
    {
        fake_user = email ? {hola_uid: `basic/${email}`,
            emails: [{value: email}],
            provider: 'basic'} : {};
    }
    return {
        is_new_user: !user,
        user: user ?? fake_user,
        email,
    };
};
